import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { FeaturesOnboarding } from 'crono-fe-common/types/DTO/featuresOnboarding';

export default function useGetUserOnboardingFeatures(enabled = true) {
  const request: Request = {
    url: ENDPOINTS.user.onboarding.features,
    config: {
      method: 'get',
    },
  };
  const requestConfig = {
    queryKey: [ENDPOINTS.user.onboarding.features],
    queryFn: () => client(request),
    enabled,
  };

  const { data, ...rest } = useQuery<
    Response<FeaturesOnboarding | null>,
    CronoError
  >(requestConfig);

  return { data, ...rest };
}
